<template>
  <div class="list-box">
    <ul class="list-search" style="margin-top: 10px">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="算税单号、名称"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-cascader
          v-model="state.withholding_agent_uid"
          :options="state.withholding_agent_data"
          :props="{ value: 'uid', label: 'name' }"
          style="width: 300px"
          placeholder="扣缴义务人"
          filterable
          clearable
          @change="onWithholdingAgentChange"
          @clear="
            delete state.params.withholding_agent_type;
            delete state.params.withholding_agent_id;
            delete state.withholding_agent_uid;
          "
        />
        <el-date-picker
          v-model="state.params.tax_month"
          type="month"
          placeholder="税款所属期"
          format="YYYY年M月"
          value-format="YYYY-MM"
        />
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="--发薪日期--"
          end-placeholder="--发薪日期--"
          style="width: 400px"
          value-format="YYYY-MM-DD"
          @change="
            (value) => {
              if (value) state.params.pay_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.pay_date;
          "
        />
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态/单号"
          prop="status"
          sortable="status"
          width="120"
          fixed="left"
        >
          <template #default="{ row }">
            <c_tabgroup :value2="row.order_id">
              <template #top>
                <div style="display: flex; align-items: center">
                  <c_status arrName="calctax_status" :value="row.status" />
                  <el-popover
                    v-if="row.calc_tax_msg"
                    placement="right"
                    trigger="hover"
                  >
                    <template #reference>
                      <el-icon
                        color="#ffa500"
                        style="margin-left: 5px; cursor: pointer"
                        ><QuestionFilled
                      /></el-icon>
                    </template>
                    <template #default>
                      <text
                        style="
                          font-size: 13px;
                          line-height: 22px;
                          color: #ffa500;
                          letter-spacing: 2px;
                        "
                        >{{ row.calc_tax_msg }}</text
                      >
                    </template>
                  </el-popover>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="160" />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          min-width="160"
        />
        <el-table-column
          prop="d_tax_type_name"
          label="报税类型"
          :formatter="$tab_TextFormat"
        />
        <el-table-column prop="tax_month" label="税款所属期" />
        <el-table-column prop="pay_date" label="发放日期" />
        <el-table-column
          prop="total_num"
          label="算税人数"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="done_num"
          label="已算税"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="undone_num"
          label="未算税"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="abnormal_num"
          label="算税失败"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Search"
              @click="
                $store.commit('openMenu', {
                  path: 'CalcTaxDetail',
                  title: '算税单详情-' + row.order_id,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customermine_calctax_list } from "@/http/customer";
import { data_withholdingagent_supplier_select } from "@/http/data";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  props: {
    customer_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.customer_id = props.customer_id;
      onLoadWithholdingAgent();
      onLoad();
    });

    //加载扣缴义务人和供应商
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_supplier_select().then((res) => {
        if (res.status == 200) {
          const { withholdingAgent, supplier } = res.data.data;
          state.withholding_agent_data = [
            {
              uid: 0,
              name: "扣缴义务人",
              children: withholdingAgent.list.map((m) => {
                return { uid: "k_" + m.id, ...m };
              }),
            },
            {
              uid: 1,
              name: "供应商",
              children: supplier.list.map((m) => {
                return { uid: "g_" + m.id, ...m };
              }),
            },
          ];
        }
      });
    };

    //选择扣缴义务人
    const onWithholdingAgentChange = (value) => {
      if (value?.length == 2) {
        state.params.withholding_agent_type = value[0];
        state.params.withholding_agent_id = value[1].substring(2);
      }
    };

    const onLoad = () => {
      delete state.tableData;

      customermine_calctax_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.Order = column.sortable;
        state.params.Asc = column.order === "ascending";
      } else {
        const params = new InitFormData().params;
        state.params.Order = params.Order;
        state.params.Asc = params.Asc;
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
      onWithholdingAgentChange,
    };
  },
};
</script>
<style scoped></style>
